import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { ProtectedRouteProps } from '../../../types';

export function ProtectedRoute({ children, userType }: ProtectedRouteProps) {
  const { user, profile, loading } = useAuth();

  console.log('ProtectedRoute - loading:', loading, 'user:', user?.id, 'profile:', profile?.userType || profile?.user_type);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user || !profile) {
    console.log('ProtectedRoute - No user or profile, redirecting to landing');
    return <Navigate to="/" replace />;
  }

  // Check user type if specified
  if (userType) {
    const actualUserType = profile.userType || profile.user_type;
    if (actualUserType !== userType) {
      console.log('ProtectedRoute - Wrong user type. Expected:', userType, 'Actual:', actualUserType);
      // Redirect to appropriate dashboard based on actual user type
      const redirectPath = actualUserType === 'professor' ? '/dashboard' : '/student-dashboard';
      return <Navigate to={redirectPath} replace />;
    }
  }

  return <>{children}</>;
} 